import MockAdapter from "axios-mock-adapter/types";
import { URL_GET_BOOKINGS_PAGED } from "@/requests/booking";
import getBookings from "./responses/getBookings";

export const bookingMock = (mock: MockAdapter): void => {
  mock.onGet(URL_GET_BOOKINGS_PAGED).reply(200, getBookings);
};
